<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="规则名称" prop="ruleName">
        <el-input
          v-model="queryParams.ruleName"
          class="!w-240px"
          clearable
          placeholder="请输入规则名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="规则类型" prop="ruleType">
        <el-select
          v-model="queryParams.ruleType"
          class="!w-240px"
          clearable
          placeholder="请选择规则类型"
        >
          <el-option label="销售" value="PRODUCT" />
          <el-option label="清洁" value="ROOM" />
          <el-option label="维修" value="SERVICE" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:commission-rule:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="规则名称" prop="ruleName" min-width="150" />
      <el-table-column align="center" label="规则类型" prop="ruleType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.ruleType === 'PRODUCT'" type="primary">销售</el-tag>
          <el-tag v-else-if="scope.row.ruleType === 'ROOM'" type="success">清洁</el-tag>
          <el-tag v-else-if="scope.row.ruleType === 'SERVICE'" type="warning">维修</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="目标类型" prop="targetType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.targetType === 'EMPLOYEE'" type="primary">员工</el-tag>
          <el-tag v-else-if="scope.row.targetType === 'POSITION'" type="success">岗位</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="目标名称" prop="targetName" min-width="120" />
      <el-table-column align="center" label="提成类型" prop="commissionType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.commissionType === 'SALES'" type="primary">销售提成</el-tag>
          <el-tag v-else-if="scope.row.commissionType === 'CLEANING'" type="success">清洁提成</el-tag>
          <el-tag v-else-if="scope.row.commissionType === 'MAINTENANCE'" type="warning">维修提成</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="计算基准" prop="calculationBase" min-width="120">
        <template #default="scope">
          <el-tag v-if="scope.row.calculationBase === 'ORDER_AMOUNT'" type="primary">订单金额</el-tag>
          <el-tag v-else-if="scope.row.calculationBase === 'ROOM_COUNT'" type="success">房间数</el-tag>
          <el-tag v-else-if="scope.row.calculationBase === 'FIXED'" type="info">固定</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提成值" prop="commissionValue" min-width="100" />
      <el-table-column align="center" label="生效日期" prop="effectiveDate" min-width="120" />
      <el-table-column align="center" label="失效日期" prop="expireDate" min-width="120" />
      <el-table-column align="center" label="状态" prop="status" min-width="80">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:commission-rule:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:commission-rule:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="规则名称" prop="ruleName">
        <el-input v-model="formData.ruleName" placeholder="请输入规则名称" />
      </el-form-item>
      <el-form-item label="规则类型" prop="ruleType">
        <el-radio-group v-model="formData.ruleType">
          <el-radio value="PRODUCT">销售</el-radio>
          <el-radio value="ROOM">清洁</el-radio>
          <el-radio value="SERVICE">维修</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="目标类型" prop="targetType">
        <el-radio-group v-model="formData.targetType">
          <el-radio value="EMPLOYEE">员工</el-radio>
          <el-radio value="POSITION">岗位</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="目标ID" prop="targetId">
        <el-input v-model="formData.targetId" placeholder="请输入目标ID" />
      </el-form-item>
      <el-form-item label="提成类型" prop="commissionType">
        <el-radio-group v-model="formData.commissionType">
          <el-radio value="SALES">销售提成</el-radio>
          <el-radio value="CLEANING">清洁提成</el-radio>
          <el-radio value="MAINTENANCE">维修提成</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="计算基准" prop="calculationBase">
        <el-radio-group v-model="formData.calculationBase">
          <el-radio value="ORDER_AMOUNT">订单金额</el-radio>
          <el-radio value="ROOM_COUNT">房间数</el-radio>
          <el-radio value="FIXED">固定</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="提成值" prop="commissionValue">
        <el-input-number
          v-model="formData.commissionValue"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="最低金额" prop="minAmount">
        <el-input-number
          v-model="formData.minAmount"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="最高金额" prop="maxAmount">
        <el-input-number
          v-model="formData.maxAmount"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="生效日期" prop="effectiveDate">
        <el-date-picker
          v-model="formData.effectiveDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择生效日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="失效日期" prop="expireDate">
        <el-date-picker
          v-model="formData.expireDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择失效日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          :rows="3"
          placeholder="请输入备注"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as CommissionRuleApi from '@/api/hotel/commissionRule'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { CommonStatusEnum } from '@/utils/constants'

defineOptions({ name: 'HotelCommissionRule' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  ruleName: undefined,
  ruleType: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await CommissionRuleApi.getCommissionRulePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<CommissionRuleApi.CommissionRuleVO>({
  id: undefined,
  shopId: undefined,
  ruleName: '',
  ruleType: 'PRODUCT',
  targetType: 'EMPLOYEE',
  targetId: 0,
  targetName: '',
  commissionType: 'SALES',
  calculationBase: 'ORDER_AMOUNT',
  commissionValue: 0,
  tierConfig: '',
  minAmount: 0,
  maxAmount: undefined,
  effectiveDate: '',
  expireDate: undefined,
  status: CommonStatusEnum.ENABLE,
  remark: '',
  createTime: undefined as any
})
const formRules = reactive({
  ruleName: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
  ruleType: [{ required: true, message: '规则类型不能为空', trigger: 'change' }],
  targetType: [{ required: true, message: '目标类型不能为空', trigger: 'change' }],
  commissionType: [{ required: true, message: '提成类型不能为空', trigger: 'change' }],
  calculationBase: [{ required: true, message: '计算基准不能为空', trigger: 'change' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await CommissionRuleApi.getCommissionRule(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await CommissionRuleApi.createCommissionRule(data)
      message.success(t('common.createSuccess'))
    } else {
      await CommissionRuleApi.updateCommissionRule(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    ruleName: '',
    ruleType: 'PRODUCT',
    targetType: 'EMPLOYEE',
    targetId: 0,
    targetName: '',
    commissionType: 'SALES',
    calculationBase: 'ORDER_AMOUNT',
    commissionValue: 0,
    tierConfig: '',
    minAmount: 0,
    maxAmount: undefined,
    effectiveDate: '',
    expireDate: undefined,
    status: CommonStatusEnum.ENABLE,
    remark: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await CommissionRuleApi.deleteCommissionRule(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
